module.exports = "//public.zight.com/packs/media/images/hero-asset-a1ae018ab543d6a8206850e9f7472222.png";